var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['tabSection', {
    internal: _vm.showBlock('internal')
  }]},[_c('div',{staticClass:"tabs-wrap"},_vm._l((_vm.internal),function(tab){return _c('tab-pill',{key:tab,attrs:{"name":tab,"active":_vm.isActiveTab(tab)},on:{"tab-click":_vm.onTabClicked}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }